import { z } from 'zod';
import type { BaseEntity } from './common';

/**
 * Activity (JobActivity) - corrisponde al modello backend
 * Utilizzabile sia per response (GET) che per payload (POST/PUT)
 */
export interface Activity extends BaseEntity {
	/** Codice identificativo dell'attività (max 100 caratteri) */
	code: string;
	/** Codice per le presenze (opzionale) */
	attendancyCode: string | null;
	/** Descrizione dell'attività */
	description: string;
	/** Indica se ha costi esclusi */
	hasExcludedCosts?: boolean | null;
	/** Indica se è un'attività per festività */
	isHolidayActivity?: boolean | null;
}

/**
 * Tipo per il risultato dell'autocomplete Activities
 * Corrisponde ai campi selezionati nella query OData: id, code, description
 */
export type ActivityAutocompleteResult = Pick<Activity, 'id' | 'code' | 'description'>;

/**
 * Schema Zod per la validazione runtime delle Activity
 */
export const ActivitySchema = z.object({
	id: z.number(),
	code: z.string(),
	attendancyCode: z.string().nullish(), // Può essere string, null o undefined
	description: z.string(),
	hasExcludedCosts: z.boolean().nullish(), // Può essere boolean, null o undefined
	isHolidayActivity: z.boolean().nullish(), // Può essere boolean, null o undefined
});
